import * as actionTypes from '../actions/actionTypes';

export default function oldEntities(state = [], action) {
  switch(action.type){
    case actionTypes.OLD_ENTITIES: {
      return action.entities;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/oldEntities.js